/**
 * @generated SignedSource<<f0e310b46854a9ec6cf5ed990e3ba1ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RsLocationSearchDialogStateQuery$variables = {
  id: string;
};
export type RsLocationSearchDialogStateQuery$data = {
  readonly viewer: {
    readonly states: {
      readonly results: ReadonlyArray<{
        readonly id: string | null;
        readonly title: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type RsLocationSearchDialogStateQuery = {
  response: RsLocationSearchDialogStateQuery$data;
  variables: RsLocationSearchDialogStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "ResultChildrenNode",
        "kind": "LinkedField",
        "name": "states",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChildrenNode",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RsLocationSearchDialogStateQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RsLocationSearchDialogStateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ca2a82e7af30cbcb875972684683e75",
    "id": null,
    "metadata": {},
    "name": "RsLocationSearchDialogStateQuery",
    "operationKind": "query",
    "text": "query RsLocationSearchDialogStateQuery(\n  $id: ID!\n) {\n  viewer {\n    states(id: $id) {\n      results {\n        id\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8649b54354771012eabc20f53454d093";

export default node;
